import React, { useCallback, useEffect, useMemo, useState } from 'react';

import PresetWrapper from './PresetWrapper';
import CollectWrapper from './CollectWrapper';
import HistoryWrapper from './HistoryWrapper';
import HotWrapper from './HotWrapper';
import { defMenu, menuLevel } from '../../../constants';
import L2Wrapper from './L2Wrapper';
import L3Wrapper from './L3Wrapper';
import L1Wrapper from './L1Wrapper';
import { useModelsModalState } from '../../../store/state';
import SearchWrapper from './SearchWrapper';
import CollectResultWrapper from './CollectResultWrapper';
import { useCols } from './hooks/useCols';

const WrapperTypeMap = {
  [defMenu.presetModelId]: PresetWrapper,
  [defMenu.collectModelId]: CollectWrapper,
  [defMenu.historyModelId]: HistoryWrapper,
  [defMenu.hotRecommendId]: HotWrapper,
};

const delRatio = '168/254';

const ContentWrapper = React.memo((props) => {
  const {
    menus,
    setMenus,
    menuPath: { menu, level },
  } = props;
  const isInGlobalSearchState = useModelsModalState('isInGlobalSearchState');
  const collectState = useModelsModalState('collectState');
  const { cols } = useCols();
  if (collectState.data) {
    return <CollectResultWrapper ratio={delRatio} cols={cols} collectState={collectState} {...props} />;
  }

  if (isInGlobalSearchState) {
    return <SearchWrapper ratio={delRatio} cols={cols} {...props} />;
  }

  if (level === menuLevel.L0) {
    const ChooseWrapper = WrapperTypeMap[menu.id];
    return (
      <>
        {ChooseWrapper ? (
          <ChooseWrapper ratio={delRatio} cols={cols} {...props} />
        ) : (
          <L1Wrapper ratio={delRatio} cols={cols} {...props} />
        )}
      </>
    );
  }
  if (level === menuLevel.L1) {
    return <L2Wrapper ratio={delRatio} cols={cols} {...props} />;
  }
  if (level === menuLevel.L2) {
    return <L3Wrapper ratio={delRatio} cols={cols} {...props} />;
  }
  return null;
});
export default ContentWrapper;
